module.exports = __webpack_public_path__ + "img/129.d416c5fd.jpg";